import React from "react";
import T from "prop-types";

import { Field, Inputs, Row } from "2g-form";

import { useServerMessage } from "b2b/i18n";
import useMessages from "./i18n/useMessages";

export function TypyZdrojuSwitch({ typZdroje, ...props } = {}) {
  const message = useServerMessage();
  const { zdrojeLabel } = useMessages();

  return !typZdroje ? null : (
    <Row asGroup>
      <Field
        key={typZdroje.typZdroje.name}
        items={typZdroje.zdroje}
        label={zdrojeLabel()}
        component={Inputs.RadioGroup}
        asSwitch
        path="zdroj"
        content={({ data }) => message(data.zdroj, "nazev")}
        {...props}
      />
    </Row>
  );
}

TypyZdrojuSwitch.propTypes = { typZdroje: T.object };

export default React.memo(TypyZdrojuSwitch);
